import type { ReactNode } from 'react';

import css from './style.module.css';

interface HeroProps {
	heading: string;
	leading: string;
	icon: ReactNode;

	children?: ReactNode | ReactNode[];
}

export function Hero({
	heading,
	leading,
	icon,

	children,
}: HeroProps): ReactNode {
	return (
		<header className={css.container}>
			{children}
			<section className={css.hero}>
				<figure role="img" className={css.icon}>
					{icon}
				</figure>
				<h1 className={css.heading}>{heading}</h1>
				<p className={css.leading}>{leading}</p>
			</section>
		</header>
	);
}
